import { render, staticRenderFns } from "./duo_single_select_options.vue.js?vue&type=template&id=313d0e4a&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_single_select_options.vue?vue&type=template&id=313d0e4a&vue3"
import script from "./duo_single_select_options.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_single_select_options.vue?vue&type=script&lang=js&vue3"
export * from "./duo_single_select_options.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./duo_single_select_options.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports